import {MLAServicePromiseClient} from 'api/mla_grpc_web_pb';
import {getEnviroment} from 'config/config';
import {enableDevTools} from "./webtool";

const env = localStorage.getItem('env');
const ENV = getEnviroment(env);

export const MLAService = new MLAServicePromiseClient(ENV);

enableDevTools([
    MLAService
]);